interface ActionType {
  LIST_REFERRALS_EMAILS_START: string;
  LIST_REFERRALS_EMAILS_SUCCESS: string;
  LIST_REFERRALS_EMAILS_FAILURE: string;
  LIST_RESPONSES_EMAILS_START: string;
  LIST_RESPONSES_EMAILS_SUCCESS: string;
  LIST_RESPONSES_EMAILS_FAILURE: string;
  GET_REFERRAL_EMAIL_DETAIL_START: string;
  GET_REFERRAL_EMAIL_DETAIL_SUCCESS: string;
  GET_REFERRAL_EMAIL_DETAIL_FAILURE: string;
  GET_RESPONSE_EMAIL_DETAIL_START: string;
  GET_RESPONSE_EMAIL_DETAIL_SUCCESS: string;
  GET_RESPONSE_EMAIL_DETAIL_FAILURE: string;
  PREVIEW_EMAIL_START: string;
  PREVIEW_EMAIL_SUCCESS: string;
  PREVIEW_EMAIL_FAILURE: string;
  RESEND_EMAIL_START: string;
  RESEND_EMAIL_SUCCESS: string;
  RESEND_EMAIL_FAILURE: string;
  RESEND_TO_OTHER_EMAIL_START: string;
  RESEND_TO_OTHER_EMAIL_SUCCESS: string;
  RESEND_TO_OTHER_EMAIL_FAILURE: string;
  DOWNLOAD_EMAIL_BODY_START: string;
  DOWNLOAD_EMAIL_BODY_SUCCESS: string;
  DOWNLOAD_EMAIL_BODY_FAILURE: string;
  SET_EMAIL_SEARCH_FILTER: string;
  CLEAR_EMAILS: string;
  CLEAR_EMAIL_BODY_DOWNLOAD: string;
  PREVIEW_RESPONSE_START: string;
}

export const EmailsActionTypes: ActionType = {
  LIST_REFERRALS_EMAILS_START: '@@LIST_REFERRALS_EMAILS_START',
  LIST_REFERRALS_EMAILS_SUCCESS: '@@LIST_REFERRALS_EMAILS_SUCCESS',
  LIST_REFERRALS_EMAILS_FAILURE: '@@LIST_REFERRALS_EMAILS_FAILURE',
  LIST_RESPONSES_EMAILS_START: '@@LIST_RESPONSES_EMAILS_START',
  LIST_RESPONSES_EMAILS_SUCCESS: '@@LIST_RESPONSES_EMAILS_SUCCESS',
  LIST_RESPONSES_EMAILS_FAILURE: '@@LIST_RESPONSES_EMAILS_FAILURE',
  GET_REFERRAL_EMAIL_DETAIL_START: '@@GET_REFERRAL_EMAIL_DETAIL_START',
  GET_REFERRAL_EMAIL_DETAIL_SUCCESS: '@@GET_REFERRAL_EMAIL_DETAIL_SUCCESS',
  GET_REFERRAL_EMAIL_DETAIL_FAILURE: '@@GET_REFERRAL_EMAIL_DETAIL_FAILURE',
  GET_RESPONSE_EMAIL_DETAIL_START: '@@GET_RESPONSE_EMAIL_DETAIL_START',
  GET_RESPONSE_EMAIL_DETAIL_SUCCESS: '@@GET_RESPONSE_EMAIL_DETAIL_SUCCESS',
  GET_RESPONSE_EMAIL_DETAIL_FAILURE: '@@GET_RESPONSE_EMAIL_DETAIL_FAILURE',
  PREVIEW_EMAIL_START: '@@PREVIEW_EMAIL_START',
  PREVIEW_EMAIL_SUCCESS: '@@PREVIEW_EMAIL_SUCCESS',
  PREVIEW_EMAIL_FAILURE: '@@PREVIEW_EMAIL_FAILURE',
  RESEND_EMAIL_START: '@@RESEND_EMAIL_START',
  RESEND_EMAIL_SUCCESS: '@@RESEND_EMAIL_SUCCESS',
  RESEND_EMAIL_FAILURE: '@@RESEND_EMAIL_FAILURE',
  RESEND_TO_OTHER_EMAIL_START: '@@RESEND_TO_OTHER_EMAIL_START',
  RESEND_TO_OTHER_EMAIL_SUCCESS: '@@RESEND_TO_OTHER_EMAIL_SUCCESS',
  RESEND_TO_OTHER_EMAIL_FAILURE: '@@RESEND_TO_OTHER_EMAIL_FAILURE',
  DOWNLOAD_EMAIL_BODY_START: '@@DOWNLOAD_EMAIL_BODY_START',
  DOWNLOAD_EMAIL_BODY_SUCCESS: '@@DOWNLOAD_EMAIL_BODY_SUCCESS',
  DOWNLOAD_EMAIL_BODY_FAILURE: '@@DOWNLOAD_EMAIL_BODY_FAILURE',
  SET_EMAIL_SEARCH_FILTER: '@@SET_EMAIL_SEARCH_FILTER',
  CLEAR_EMAILS: '@@CLEAR_EMAILS',
  CLEAR_EMAIL_BODY_DOWNLOAD: '@@CLEAR_EMAIL_BODY_DOWNLOAD',
  PREVIEW_RESPONSE_START: '@@PREVIEW_RESPONSE_START'
};

export interface EmailsState {
  emails?: OutboundEmailsResponse;
  emailDetail?: any;
  listing?: boolean;
  loading?: boolean;
  resending?: boolean;
  resendingToOther?: boolean;
  previewing?: boolean;
  downloading?: boolean;
  filters?: ReferralEmailSearchFilters | ResponseEmailSearchFilters;
  emailPreview?: any;
  emailBodyDownload?: any;
  resendedId?: number;
}

export interface OutboundEmailsResponse {
  OutboundEmails: any[];
  Info: {
    count: number;
    limit: number;
    offset: number;
  };
}

export interface AssetOwnerTableRowData {
  id: string;
  sent: string;
  referral?: number;
  job?: number;
  toEmail?: string;
  status: string;
}

export interface ReferralEmailSearchFilters {
  createdAfter: string;
  createdBefore: string;
  status: string[];
  externalId: string;
}

export interface ResponseEmailSearchFilters {
  createdAfter: string;
  createdBefore: string;
  status: string[];
  externalId: string;
  subject: string;
}

export interface AssetOwnerEmailSearchFormInitialValues {
  dateRange: string;
  createdAfter: string;
  createdBefore: string;
  status: string[];
  externalId: string;
  subject?: string;
}

export type EmailStatus =
  | 'bounce'
  | 'deferred'
  | 'delivered'
  | 'dropped'
  | 'open'
  | 'processed'
  | 'spamreport'
  | 'unsubscribed'
  | 'click';
